/* HealthSpot services: help button, consultation pre-select, analytics events and prescription cart guard. */
(function () {
  function pub(name, detail) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail || {}); } catch (e) {}
  }
  window.hsPublish = pub;

  /* 1. Analytics: any element with data-hs-ev publishes a custom event on click (visible in Customer events / pixels). */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-hs-ev]');
    if (el) pub(el.getAttribute('data-hs-ev'), { label: el.getAttribute('data-hs-label') || '', path: location.pathname });
  });
  /* Success states rendered by Liquid after a form post (consultation requested, club joined, journey started). */
  document.querySelectorAll('[data-hs-success]').forEach(function (el) {
    pub(el.getAttribute('data-hs-success'), { path: location.pathname });
    try { el.focus(); el.scrollIntoView({ block: 'center' }); } catch (e) {}
  });
  /* Page views of the service hub pages (journey funnel). */
  var svcPages = { '/pages/weight-management': 'weight_management', '/pages/consultations': 'consultations', '/pages/wellness-club': 'wellness_club', '/pages/skin-analysis': 'skin_analysis', '/pages/services': 'services' };
  var p = location.pathname.replace(/\/$/, '');
  if (svcPages[p]) pub('hs_service_page_view', { service: svcPages[p] });

  /* 2. Help button */
  var help = document.querySelector('[data-hs-help]');
  if (help) {
    if (help.parentNode !== document.body) document.body.appendChild(help); /* escape sticky-header stacking context */
    var btn = help.querySelector('[data-hs-help-btn]'), panel = help.querySelector('.hs-help__panel');
    var set = function (open) { panel.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (open) { pub('hs_help_open', { path: location.pathname }); var a = panel.querySelector('a'); a && a.focus(); } };
    btn.addEventListener('click', function () { set(panel.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!panel.hidden && !help.contains(e.target)) set(false); });
  }

  /* 3. Consultation pre-select: ?service=handle or a "Book …" button with data-hs-pick */
  function pick(handle) {
    document.querySelectorAll('[data-hs-service-select]').forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) { if (o.getAttribute('data-handle') === handle) sel.value = o.value; });
    });
  }
  var q = new URLSearchParams(location.search).get('service');
  if (q) {
    pick(q);
    if (location.hash === '#book') { var f = document.querySelector('.hs-bookform'); if (f) setTimeout(function () { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150); }
  }
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-hs-pick]'); if (b) pick(b.getAttribute('data-hs-pick')); });

  /* 4. Prescription guard: prescription-only medicines can't be bought through the cart. Remove any that got in. */
  var rx = (window.hsSvc && window.hsSvc.rxLines) || [];
  if (rx.length) {
    var updates = {}; rx.forEach(function (k) { updates[k] = 0; });
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () {
        pub('hs_rx_removed_from_cart', { count: rx.length });
        alert('A prescription-only medicine was removed from your cart. Prescription medicines are supplied only after our pharmacist verifies a valid prescription. Please use "Send prescription" on the product page.');
        location.reload();
      }).catch(function () {});
  }
})();
